import React, { ReactNode, useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import logo from "../../../../../../assets/images/logo.png";
import { TkBasicHeaderProps } from "../../../../../../type/componentsType/TkHeaderType";
import { HeaderContext } from "../../../index";
import authorityUserType from "../../../../../../assets/data/TkAuthorityProperty";
import "./_style.scss";

/**
 * ヘッダー部品
 * 共済契約のお申込み画面のヘッダーを表示します。
 * @param {TkBasicHeaderProps} props - TkHeaderコンポーネントのprops
 * @param {ReactNode} props.children - 子要素
 * @param {number} props.sideBarWidth - サイドバーの幅
 * @param {boolean} props.hideButton - ボタンを非表示にするかどうかのフラグ
 * @param {string} props.userType - ユーザータイプ
 * @return TkHeader ヘッダー部品
 */
export const TkBasicHeader: React.FC<TkBasicHeaderProps> & {
  Slot: React.FC<any>;
} = (props) => {
  const { children, sideBarWidth, hideButton, userType } = props;

  const [headerClassName, setHeaderClassName] = useState("tkHeader");
  let leftSlot: ReactNode = <></>;
  let rightSlot: ReactNode = <></>;
  const title = useContext(HeaderContext);
  const isShow = userType === authorityUserType.userTypeNumber.KIKO;

  useEffect(() => {
    if (isShow) {
      if (sideBarWidth === 330) {
        setHeaderClassName("tkHeader activeLong");
      } else if (sideBarWidth === 75) {
        setHeaderClassName("tkHeader activeShort");
      } else {
        setHeaderClassName("tkHeader");
      }
    } else {
      setHeaderClassName("tkHeader");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isShow) {
      if (sideBarWidth === 330) {
        setHeaderClassName("tkHeader activeLong");
      } else if (sideBarWidth === 75) {
        setHeaderClassName("tkHeader activeShort");
      } else {
        setHeaderClassName("tkHeader");
      }
    } else {
      setHeaderClassName("tkHeader");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBarWidth]);
  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child) && child.type === TkBasicHeader.Slot) {
      if (child.props.slot === "left") {
        leftSlot = child;
      } else if (child.props.slot === "right") {
        rightSlot = child;
      }
    }
  });

  return (
    <Box className={headerClassName} data-testid={headerClassName}>
      <Box className="tkHeaderLeft">
        {leftSlot && !hideButton && (
          <Box className="leftSlot" data-testid="leftSlot">
            {leftSlot}
          </Box>
        )}
        <Box className="tkHeaderText">
          <Box className="tkHeaderLogo">
            <Box className="logo">
              <img src={logo} alt="logo" />
            </Box>
            <Typography className="miniTitle">退職手当共済システム</Typography>
          </Box>
          <Typography className="pageTitle">{title}</Typography>
        </Box>
      </Box>

      {rightSlot && (
        <Box className="rigtSlot" data-testid="rightSlot">
          {rightSlot}
        </Box>
      )}
    </Box>
  );
};

TkBasicHeader.Slot = (props: any) => {
  const { children } = props;

  return <>{children}</>;
};

export default TkBasicHeader;
